"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _logo = _interopRequireDefault(require("./logo.png"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default() {
  return /*#__PURE__*/_react["default"].createElement("header", {
    className: "navbar",
    style: {
      margin: 0
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "navbar-brand"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "Quest",
    className: _style["default"].logo,
    src: _logo["default"]
  }))));
};